import { EventEmitter } from '@angular/core';
import { ImageService } from '../../../services/image.service';
import { bindFunctionsToThis } from '../../extensions';
import * as jwt_decode from "jwt-decode";
import { GlobalEventEmitter } from "../../services/global.event.emitter";
var GoogleLoginButtonComponent = /** @class */ (function () {
    function GoogleLoginButtonComponent(imageService) {
        var _this = this;
        this.imageService = imageService;
        this.onLoginStatusChanged = new EventEmitter();
        bindFunctionsToThis(this);
        try {
            setTimeout(function () {
                _this.initializeGoogle();
            }, 2000);
        }
        catch (e) {
            console.warn(e);
        }
    }
    GoogleLoginButtonComponent.prototype.initializeGoogle = function () {
        var _this = this;
        console.log('initializing google');
        google['accounts'].id.initialize({
            client_id: '665289826545-463bhl103plveo5l05b94vjnenmr3f7e',
            callback: function (data) {
                console.log('google initialized', data);
                if (data['credential']) {
                    var credential = jwt_decode(data['credential']);
                    console.log('credential', credential);
                    _this.profilePicture = credential['picture'];
                    GoogleLoginButtonComponent.isUserLoggedWithGoogle = true;
                    GoogleLoginButtonComponent.googleUserId = credential['email'];
                    GoogleLoginButtonComponent.profilePicture = _this.profilePicture;
                    console.log("googleId: " + GoogleLoginButtonComponent.googleUserId);
                    _this.onLoginStatusChanged.emit(true);
                    // notify share.trip.modal.component to close the modal
                    GlobalEventEmitter.emit('onGoogleLoginStatusChanged');
                }
            }
        });
        google['accounts'].id.renderButton(document.getElementById("google-signin-btn"), { theme: "outline", size: "large" });
    };
    GoogleLoginButtonComponent.prototype.login = function () {
    };
    GoogleLoginButtonComponent.prototype.logout = function () {
        if (this.isUserLoggedWithGoogle) {
            google['accounts'].id.disableAutoSelect();
            GoogleLoginButtonComponent.isUserLoggedWithGoogle = false;
            this.onLoginStatusChanged.emit(false);
        }
    };
    Object.defineProperty(GoogleLoginButtonComponent.prototype, "isUserLoggedWithGoogle", {
        get: function () {
            return GoogleLoginButtonComponent.isUserLoggedWithGoogle;
        },
        enumerable: true,
        configurable: true
    });
    return GoogleLoginButtonComponent;
}());
export { GoogleLoginButtonComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/google.login.button/google.login.button.component.ts.pre-build-optimizer.js